import type { ApiDispatcher } from '@app/packages/api/ApiDispatcher'

import { createThunk } from '@app/store/thunk'

export const getApiDispatcher = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().lookupEnsure<ApiDispatcher>(ApiDispatcherSymbol)
  })

export const setApiDispatcher = (dispatcher: ApiDispatcher) =>
  createThunk((_dispatch, _getState, context) => {
    context.getRootContext().set(ApiDispatcherSymbol, dispatcher)
  })

const ApiDispatcherSymbol = Symbol('apiDispatcher')
